// start:ng42.barrel
export * from './hotel.model';
export * from './hotel-image.model';
export * from './hotel-address.model';
export * from './hotel-region.model';
export * from './hotel-extra-feature.model';
export * from './hotel-extra-feature-type.model';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/hotel/index.ts